import { render, staticRenderFns } from "./peoplePie.vue?vue&type=template&id=67d8433c&scoped=true"
import script from "./peoplePie.vue?vue&type=script&lang=js"
export * from "./peoplePie.vue?vue&type=script&lang=js"
import style0 from "./peoplePie.vue?vue&type=style&index=0&id=67d8433c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d8433c",
  null
  
)

export default component.exports